export default "__VITE_ASSET__Cp8O9LfC__"